import {FC} from 'react'

import cn from 'classnames/bind'

import s from './SecureBlock.module.scss'

const cx = cn.bind(s)

interface ISecureBlockProps {
	className?: string
}

const SecureBlock: FC<ISecureBlockProps> = ({className}) => (
	<div className={cx('wrapper', className)}>
		{/* eslint-disable-next-line @next/next/no-img-element */}
		<img src="/images/checkout/norton-secure.jpg" width={97} height={52} alt="Norton secure logo" />
		{/* eslint-disable-next-line @next/next/no-img-element */}
		<img
			src="/images/checkout/mcafee-secure.png"
			width={114}
			height={43}
			alt="MCafee secure logo"
		/>
	</div>
)

export default SecureBlock
